// Module
var code = "<div class=\"student-helper-assignment-export-hidden\"> <assignment-sheet config=\"ctrl.currentConfig\"></assignment-sheet> </div> <div class=\"student-helper-assignment-export-scripts\"></div> <student-helper-teacher-react/> ";
// Exports
module.exports = code;